import { apiRequest } from './apiClient';

export type SyncedLiability = {
  liabilityId: string;
  type: string;
  label: string;
  balance: number;
  interestRatePct?: number;
  monthlyPayment?: number;
  termYears?: number;
  ownerUserId: string;
  hiddenFromHousehold: boolean;
  updatedAt: string;
};

export async function fetchLiabilities(
  view?: 'personal' | 'combined',
): Promise<SyncedLiability[]> {
  const params = new URLSearchParams();
  if (view) params.set('view', view);
  const q = params.toString();
  const res = await apiRequest<{ liabilities: SyncedLiability[] }>(
    `/liabilities${q ? `?${q}` : ''}`,
  );
  return res.liabilities ?? [];
}

export async function saveLiabilities(
  liabilities: Array<{
    liabilityId: string;
    type: string;
    label: string;
    balance: number;
    interestRatePct?: number;
    monthlyPayment?: number;
    termYears?: number;
    hiddenFromHousehold?: boolean;
  }>,
): Promise<SyncedLiability[]> {
  const res = await apiRequest<{ liabilities: SyncedLiability[] }>('/liabilities', {
    method: 'PUT',
    body: JSON.stringify({ liabilities }),
  });
  return res.liabilities ?? [];
}
